var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D66700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.26 10.9996C16.17 10.8596 12 14.9496 12 19.9996H10.21C9.76 19.9996 9.54 20.5396 9.86 20.8496L12.65 23.6496C12.85 23.8496 13.16 23.8496 13.36 23.6496L16.15 20.8496C16.2191 20.7791 16.2658 20.6897 16.2842 20.5927C16.3026 20.4957 16.2918 20.3955 16.2533 20.3046C16.2148 20.2137 16.1503 20.1362 16.0678 20.0819C15.9854 20.0277 15.8887 19.999 15.79 19.9996H14C14 16.0996 17.18 12.9496 21.1 12.9996C24.82 13.0496 27.95 16.1796 28 19.8996C28.05 23.8096 24.9 26.9996 21 26.9996C19.39 26.9996 17.9 26.4496 16.72 25.5196C16.5285 25.3687 16.2881 25.2935 16.0448 25.3082C15.8014 25.323 15.5719 25.4267 15.4 25.5996C14.98 26.0196 15.01 26.7296 15.48 27.0896C17.0511 28.3321 18.997 29.0053 21 28.9996C26.05 28.9996 30.14 24.8296 30 19.7396C29.87 15.0496 25.95 11.1296 21.26 10.9996ZM20.75 15.9996C20.34 15.9996 20 16.3396 20 16.7496V20.4296C20 20.7796 20.19 21.1096 20.49 21.2896L23.61 23.1396C23.97 23.3496 24.43 23.2296 24.64 22.8796C24.85 22.5196 24.73 22.0596 24.38 21.8496L21.5 20.1396V16.7396C21.5 16.3396 21.16 15.9996 20.75 15.9996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareHistory);
export default __webpack_public_path__ + "static/media/share-history.e077f29b1c9b8a894d4c22f250d405df.svg";
export { ForwardRef as ReactComponent };